import { t } from '@lingui/macro'
import { ErrorBoundary } from '@sentry/react'
import React, { FC } from 'react'

import { CustomisedFeedObjectQuestion } from '../NewQuestion'
import Background from '../Showcase/Background'
import Title from '../Showcase/Title'
import styles from './ChannelQuestion.module.css'
import QuestionComponent from './QuestionComponent'

const section = 'qa'

type Props = {
  data: Array<CustomisedFeedObjectQuestion>
}

const ChannelQuestion: FC<Props> = ({ data }) => {
  const schema = {
    actionUrl: '/qa',
    subTitle: t`Asked by similar women`,
    title: t`Question & Answers for you`,
  }

  return (
    <ErrorBoundary fallback={<></>}>
      <div className={styles.marginBottom}>
        <Background />
        <div className={styles.channelQuestionWrapper}>
          <div className={styles.channelQuestionTitle}>
            <Title schema={schema} section={section} styles={styles} />
          </div>
          <div className={styles.channelQuestionWrapperItems}>
            {data && data.slice(0, 3).map(item => <QuestionComponent key={item.id} item={item} />)}
          </div>
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default ChannelQuestion
